import { NoResult, UrlHelper } from '@devex/devex-shared';
import { authenticatedFetch } from '@shopify/app-bridge-utils';
import { ClientApplication } from '@shopify/app-bridge';
import { ConfigService } from './config-service';
import { SessionStorageService } from './session-storage-service';

export class HttpService {
	public constructor(private readonly _configService: ConfigService) {
	}

	public static readonly id = 'http-service';

	private static _fetchFunction: (uri: RequestInfo, options?: RequestInit | undefined) => Promise<Response> = (_, _1) => Promise.reject(new Error('too early'));

	public static initialize(app: ClientApplication) {
		const authFetchFunction = authenticatedFetch(app);

		HttpService._fetchFunction = async (uri: RequestInfo, options?: RequestInit | undefined) => {
			const response = await authFetchFunction(uri, options);

			if (response.status === 401) {
				const qs = UrlHelper.parseQueryStringFromLocation(window);

				window.location.href = `/auth?shop=${qs.shop}&host=${qs.host}`;
			}

			return response;
		};
	}

	public async get<T>(relativeUrl: string): Promise<T> {
		const sessionShop = SessionStorageService.getShopOverride();

		const header = sessionShop ? { 'X-BGT-SHOP': sessionShop } : {};

		const response = await HttpService._fetchFunction(`${relativeUrl}?shop=boardgametables-dev.myshopify.com`, {
			method: 'get',
			headers: header,
		});

		const body = await response.json();

		return body;
	}

	public async getRaw(relativeUrl: string): Promise<string> {
		const sessionShop = SessionStorageService.getShopOverride();

		const header = sessionShop ? { 'X-BGT-SHOP': sessionShop } : {};

		const response = await HttpService._fetchFunction(relativeUrl, {
			method: 'get',
			headers: header,
		});

		const body = await response.text();

		return body;
	}

	public async post<T>(relativeUrl: string, body: T): Promise<NoResult> {
		const sessionShop = SessionStorageService.getShopOverride();

		const header = sessionShop ? {
			'Content-Type': 'application/json',
			'X-BGT-SHOP': sessionShop,
		} : { 'Content-Type': 'application/json' };

		const request: RequestInit = {
			method: 'post',
			headers: header,
			body: JSON.stringify(body),
		};

		await HttpService._fetchFunction(relativeUrl, request);

		return NoResult.instance;
	}

	public async postWithResponse<T>(relativeUrl: string, body: any): Promise<T> {
		const sessionShop = SessionStorageService.getShopOverride();
		const header = sessionShop ? {
			'Content-Type': 'application/json',
			'X-BGT-SHOP': sessionShop,
		} : { 'Content-Type': 'application/json' };
		const request: RequestInit = {
			method: 'post',
			headers: header,
			body: JSON.stringify(body),
		};
		const response = await HttpService._fetchFunction(relativeUrl, request);
		const responseBody = await response.json();
		return responseBody;
	}

	public async put<T>(relativeUrl: string, body: T): Promise<NoResult> {
		const sessionShop = SessionStorageService.getShopOverride();
		const header = sessionShop ? {
			'Content-Type': 'application/json',
			'X-BGT-SHOP': sessionShop,
		} : { 'Content-Type': 'application/json' };
		const request: RequestInit = {
			method: 'put',
			headers: header,
			body: JSON.stringify(body),
		};
		await HttpService._fetchFunction(relativeUrl, request);
		return NoResult.instance;
	}
}
